import { localeString } from '@/config/helpers.js'

export const rfvIndicatorsEvolution = {
  data: () => ({
    notLocaleKeys: ['clients', 'frequency', 'recency', 'revenue', 'tickets'],
    currencyKeys: ['revenue', 'monthlyAverageRevenuePerClient', 'averageTicket'],
    percentageKeys: ['percentageTickets', 'percentageRevenue'],
  }),

  methods: {
    getClientCurrentMetric(key, customSelectedValue = '') {
      const selectedValue = this.selectedValue || customSelectedValue
      return this.currentClientsMetrics.hasOwnProperty(key) ? this.currentClientsMetrics[key].metrics[selectedValue] : null
    },
    getClientReferenceMetric(key, customSelectedValue = '') {
      const selectedValue = this.selectedValue || customSelectedValue
      return this.referenceClientsMetrics.hasOwnProperty(key) ? this.referenceClientsMetrics[key].metrics[selectedValue] : null
    },
    getVariation(referenceValue, currentValue, customSelectedValue = '') {
      const selectedValue = this.selectedValue || customSelectedValue
      if (referenceValue > 0 && currentValue > 0) {
        return this.percentageKeys.includes(selectedValue) ? currentValue - referenceValue : (currentValue / referenceValue) * 100 - 100
      } else {
        return 0
      }
    },
    getIndicatorValue(value, locale, key, customSelectedValue = '') {
      const selectedValue = this.selectedValue || customSelectedValue
      if (selectedValue === 'recency') return this.formatRecency(value, key)
      if (key === 'losses' && this.setHifen && !value) {
        return '-'
      } else {
        const currency = this.currencyKeys.includes(selectedValue) ? 'R$ ' : ''
        const percentage = this.percentageKeys.includes(selectedValue) ? '%' : ''
        return currency + localeString(value, locale) + percentage
      }
    },
    getIndicatorVariation(indicator) {
      if (this.selectedValue === 'recency') {
        const { currentValue, referenceValue } = indicator
        if (currentValue === referenceValue) return 0
        else if (referenceValue > currentValue) return 1
        return -1
      }

      return indicator.variation
    },
    getIndicatorIsReversed({ key, type } = {}) {
      if (type === 'clients' && ['atRisk', 'lowValue', 'losses'].includes(key)) return true
      return false
    },
    formatRecency(recency = 0, key) {
      if (recency === 0) {
        if (key === 'losses') return '-'
        return 'até 7 dias'
      } else {
        const start = recency * 7 + 1
        const end = (recency + 1) * 7
        return `${start} a ${end} dias`
      }
    },
  },
}
